import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadCompraqui: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source="COMPRAQUI" title="Importar catálogo Compraqui"
  instructions="Copie a URL completa do cardápio digital da sua loja na Compraqui."
  placeholder="https://sua-loja.compraqui.app/" />;

export default UploadCompraqui;
